import React from "react";
import Button from "./Button";

const TablePagination = ({
  currentPage,
  totalPages,
  totalEntries,
  itemsPerPage,
  onPageChange,
  className = "",
}) => {
  const startEntry = totalEntries > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0;
  const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);

  return (
    <div className={["flex flex-col sm:flex-row items-center justify-between gap-4 mt-4 pt-4 border-t border-border text-xs font-semibold text-ink-500", className].join(" ")}>
      <div>
        Showing {startEntry} to {endEntry} of {totalEntries} entries
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span className="px-3 py-1.5 bg-canvas border border-border rounded-lg text-ink-700">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default TablePagination;
